import axios from "axios";
import { useEyeconxStore } from "../store/eyeconxStore";

export const API_URL = process.env.REACT_APP_API_URL;
const axiosNew = axios.create({
    baseURL: API_URL,
})

axiosNew.interceptors.request.use(
    (config) => {
        const token = useEyeconxStore.getState().token;
        if (token) {
            config.headers.Authorization = "Bearer " + token;
        }

        // FormData must keep browser-set multipart boundary; never force JSON Content-Type
        const isMultipart =
            config.isMultipart === true ||
            (typeof FormData !== 'undefined' && config.data instanceof FormData);

        if (!isMultipart) {
            config.headers['Content-Type'] = 'application/json;charset=UTF-8';
            config.headers['Accept'] = 'application/json';
        } else if (config.headers) {
            // Let the browser/axios set multipart/form-data; boundary
            delete config.headers['Content-Type'];
        }

        return config;
    },
    (error) => {
        console.log("Error in Interceptor");
        return Promise.reject(error);
    }
);

let isLoggingOut = false;

axiosNew.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 403 && !isLoggingOut) {
            isLoggingOut = true;
            const { logout } = useEyeconxStore.getState();
            logout();
            isLoggingOut = false;
        }
        return Promise.reject(error);
    }
);

export default axiosNew;